<template>
    <div>
        <div v-for="(item,i) of runLog" :key="i" style="margin-top: 5px">
            <div style="float: left;margin-right: 5px">
                <button class="form-control" disabled="true">{{i+1}}</button>
            </div>
            <div>
                <input type="text" class="form-control col-md-5" v-model="runLog[i]">
            </div>
        </div>
        <button class="btn btn-primary" type="button" style="margin-top:5px" @click="onAdd">{{$t('lbl.shiftHandOver.addEvent')}}</button>
        <button class="btn btn-primary" type="button" style="margin-top:5px;margin-left: 5px" @click="onDelete">{{$t('lbl.shiftHandOver.deleteEvent')}}</button>
    </div>
</template>

<script>
import { mapState } from "vuex";
    export default {
        name:"DynamicForm",
        data() {
            return {
                items: []
            }
        },
        computed: {
            ...mapState({
                runLog: state => state.shiftHandOver.entity.runLog
            })
        },
        methods: {
            onAdd() {
                this.runLog.push('')
            },
            onDelete(){
                this.runLog.pop()
            }
        }
    }
</script>